export enum GlobalModalsType {
  ProductSwitch = 100,
  ClientCoolOff,
  RegisterProduct,
  CancelAction,
  CancelSwitch,
  ProductInfo,
  BrowserOutdated,
  DeleteNotification,
  LuckyDraw,
  AddCampaignAccount,
}
